export enum OutgoingDeliveryCreationMethodEnum {
  AUTOMATICALLY = 'automatically',
  MANUALLY = 'manually',
}
